<div id="connection-overlay" *ngIf="showOverlay">
    <h2>Connection lost. Attempting to reconnect</h2>
</div>
